import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as engagementService from '_services/engagements'

export const CREATE_ENGAGEMENT_ENTRY = defineAction('CREATE_ENGAGEMENT_ENTRY')
export const GET_ENGAGEMENT_ENTRIES = defineAction('GET_ENGAGEMENT_ENTRIES')

export const createEngagementEntry = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_ENGAGEMENT_ENTRY.ACTION,
    payload: engagementService
      .createEngagementEntry(getState().user.get('token'))(payload)
      .then(() => engagementService.getEngagementEntries(getState().user.get('token'))),
  })

export const getEngagementEntries = () => (dispatch, getState) =>
  dispatch({
    type: GET_ENGAGEMENT_ENTRIES.ACTION,
    payload: engagementService.getEngagementEntries(getState().user.get('token')),
  })



// WEBPACK FOOTER //
// ./src/modules/engagement/actions.js